import { TRoutes } from "@/types/routes"
import {
  NavigationMenuRoutes,
  ManagementMenuRoutes,
  MTTEntities,
} from "toptaal-shared"

export const navigationItems: NavigationMenuRoutes<TRoutes>[] = [
  { label: "Todo", path: "/todo" },
  { label: "Beheer", path: "/beheer" },
  { label: "Dashboard", path: "/dashboard" },
  { label: "Agenda", path: "/agenda", teacherOnly: true },
  { label: "Correspondentie", path: "/correspondentie" },
  { label: "Test support", path: "/test-support" },
  {
    label: "Facturatie",
    path: "/facturatie",
    permissionEntity: "invoices",
  },
  { label: "DUO", path: "/duo", permissionEntity: "duo" },
]

export const managementItems: ManagementMenuRoutes<TRoutes, MTTEntities>[] = [
  { label: "Cursisten", path: "/beheer/cursisten", entity: "students" },
  { label: "Lessen", path: "/beheer/lessen", entity: "planning" },
  // This is commented out because it's not sure if it's needed
  // { label: "Facturering", path: "/beheer/facturering" },
  {
    label: "Groepen",
    path: "/beheer/groepen",
    entity: "groups",
  },
  {
    label: "Roosters",
    path: "/beheer/roosters",
    entity: "planning",
  },
  {
    label: "Medewerkers",
    path: "/beheer/medewerkers",
    entity: "employees",
  },
  {
    label: "Intake",
    path: "/beheer/intakes",
    entity: "intake",
  },
  {
    label: "Organisaties",
    path: "/beheer/organisaties",
    entity: "organizations",
  },
  {
    label: "Contactpersonen",
    path: "/beheer/contactpersonen",
    entity: "contacts",
  },
  {
    label: "Contracten",
    path: "/beheer/contracten",
    entity: "projects",
  },
  { label: "Leerlijnen", path: "/beheer/leerlijnen", entity: "curriculum" },
  { label: "Locaties", path: "/beheer/locaties", entity: "locations" },
  {
    label: "Lesmaterialen",
    path: "/beheer/lesmaterialen",
    entity: "teachingMaterials",
  },
  { label: "Toetsen", path: "/beheer/toetsen", entity: "exams" },
  { label: "Feestdagen", path: "/beheer/feestdagen", entity: "holidays" },
  { label: "Laptops", path: "/beheer/laptops", entity: "laptops" },
]

export const facturationMenuItems: ManagementMenuRoutes<
  TRoutes,
  MTTEntities
>[] = [
  {
    label: "Cursisten",
    entity: "students",
    path: "/facturatie/cursisten",
  },
  {
    label: "Facturen",
    entity: "invoices",
    path: "/facturatie/facturen",
  },
  // TODO: Add item for duo
  // {
  //   label: "DUO",
  //   entity: "duo",
  //   path: "/facturatie/duo",
  // },
]

export const duoMenuItems: ManagementMenuRoutes<TRoutes, MTTEntities>[] = [
  {
    label: "Contractenlijsten",
    entity: "duo",
    path: "/duo/contractenlijsten",
  },
  {
    label: "Terugmeldingen",
    entity: "duo",
    path: "/duo/terugmeldingen",
  },
  {
    label: "Examenresultaten",
    entity: "duo",
    path: "/duo/examenresultaten",
  },
  {
    label: "Facturen",
    entity: "duo",
    path: "/duo/facturen",
  },
]
